import React, { Component } from 'react';

import NavbarLogo from './navbar/NavbarLogo';
import NavbarBody from './navbar/NavbarBody';

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */
export default class AppNavbar extends Component {

    // --------------------------------------------------------------------------------
    // MAIN RENDER FUNCTION
    // --------------------------------------------------------------------------------

    render() {
        return (
            <header id="header" className={`header ${this.props.fillBackground === true ? "" : "header-bg-transparent"} header--show-hide-md`}
                data-header-fix-moment="400" data-header-fix-effect="slide">
                <div className="header-section">
                    <div id="logoAndNav" className="container">
                        <nav className="navbar navbar-expand-md px-3 py-2">
                            <NavbarLogo />
                            <NavbarBody className="nav flex-column flex-md-row" full />
                        </nav>
                    </div>
                </div>
            </header>
        );
    }
}